import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type GetTransactionsResponse } from '@shared/api';

interface UseTransactionsStore {
  loading: boolean;
  data: GetTransactionsResponse[];
  error: string | null;
  getTransactions: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTransactionsStore = create<UseTransactionsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getTransactions: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountsApi.getTransactions(id, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
